import { DayAttendanceType, LabelMapper } from 'types';
import { journalTexts } from 'consts/text';

export const dayAttendanceTypesLabels: LabelMapper<DayAttendanceType> = {
    PRESENT: journalTexts.journalDetails.groupJournal.attendance.daily.present,
    ABSENT: journalTexts.journalDetails.groupJournal.attendance.daily.notReportedAbsentShort,
    ABSENT_PLANNED: journalTexts.journalDetails.groupJournal.attendance.daily.plannedAbsentShort,
    REMOTE: journalTexts.journalDetails.groupJournal.attendance.daily.remoteAbsent,
};
